import React, { useState } from "react";

// A simple, reusable question/answer accordion.
// `items` looks like: [{ q: "Question text", a: "Answer text" }, ...]
// Only one item is open at a time; click the open item again to close it.
export default function Accordion({ items, defaultOpenIndex = 0 }) {
  const [openIndex, setOpenIndex] = useState(defaultOpenIndex);

  const toggle = (index) => {
    setOpenIndex((current) => (current === index ? -1 : index));
  };

  return (
    <div className="accordion-mu">
      {items.map((item, i) => {
        const isOpen = openIndex === i;
        return (
          <div className={`accordion-item-mu ${isOpen ? "open" : ""}`} key={i}>
            <button
              type="button"
              className="accordion-item-mu-header"
              onClick={() => toggle(i)}
            >
              <span>{item.q}</span>
              <svg width="14" height="14" fill="currentColor" viewBox="0 0 16 16" className="accordion-chevron">
                <path d="M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708Z" />
              </svg>
            </button>
            {isOpen && <p className="accordion-item-mu-body">{item.a}</p>}
          </div>
        );
      })}
    </div>
  );
}
